<template>
  <svg
    class="icon"
    :style="{ height: height + 'px', width: width + 'px', fill: color }"
    :class="`icon--${iconName}`"
    :alt="alt"
    @mouseenter="getHoverIcon"
    @mouseleave="getDefaultIcon"
  >
    <use :xlink:href="svgLink"></use>
  </svg>
</template>

<script lang="js">
  export default  {
    name: 'lms-icon',
    components: {

    },
    props: {
      iconName: {
        type: String,
        required: true,
      },
      iconNameHover: {
        type: String,
        default: null,
      },
      height: {
        type: String,
        default: "",
      },
      width: {
        type: String,
        default: "",
      },
      color: { type: String },
      alt: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        svgLink: this.getLink(this.iconName)
      }
    },
    mounted () {

    },
    methods: {
      getLink: (iconName) => {
        return `/app/themes/liberator/src/assets/fonts/icons.svg#${iconName}`
      },
      getHoverIcon() {
        this.svgLink = (this.iconNameHover) ? this.getLink(this.iconNameHover) : this.getLink(this.iconName);
      },
      getDefaultIcon() {
        this.svgLink = this.getLink(this.iconName);
      }
    },
}
</script>
